export const LATEST_PURCHASE_FILTER = {
  where: { next_payment_date: { neq: null } },
  order: "next_payment_date DESC",
  limit: 1,
};

export function isPurchaseExpired(latestPurchase, asOf = new Date()) {
  const nextPaymentDate = latestPurchase?.next_payment_date
    ? new Date(latestPurchase.next_payment_date)
    : null;

  if (!nextPaymentDate || Number.isNaN(nextPaymentDate.getTime())) {
    return false;
  }

  return asOf > nextPaymentDate;
}

export function hasScreenerGradeAccess(
  assessment,
  { latestPurchase, isPilot = false } = {}
) {
  if (isPilot) {
    return true;
  }

  if (!latestPurchase || isPurchaseExpired(latestPurchase)) {
    return false;
  }

  return (
    (assessment?.grade_level1 === true &&
      latestPurchase.gradelevel1_screeners === true) ||
    (assessment?.grade_level2 === true &&
      latestPurchase.gradelevel2_screeners === true) ||
    (assessment?.grade_level3 === true &&
      latestPurchase.gradelevel3_screeners === true)
  );
}

export function isScreenerAvailable(
  assessment,
  { isConfigured = false, purchaseAccessError = false, ...accessContext } = {}
) {
  return (
    !purchaseAccessError &&
    isConfigured === true &&
    hasScreenerGradeAccess(assessment, accessContext)
  );
}
